





























































































import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';
import { FETCH_ORG_PRICES, FETCH_ORG_PRODUCTS } from '@/store/action-types';
import { ICustomAttribute, ISegmentFilter, IState, SegmentAttribute, SegmentOperand, IExclusion } from '@/store/types';
import VerticalLine from '@/components/UI/VerticalLine.vue';
import SegmentFilterEditor from '@/components/Builder/SegmentFilterEditor.vue';
import CustomAttributeEditor from '@/components/UI/CustomAttributeEditor.vue';
import {
  CUSTOM_ATTRIBUTE_TYPE,
  ENABLED_SEGMENT_ATTRIBUTES,
  getDefaultFilterValue,
  SAVE_STATE,
  segmentAttributeLabels,
  SEGMENT_ATTRIBUTE,
  SEGMENT_OPERAND,
  SEGMENT_ATTRIBUTE_TYPE,
} from '@/store/shared';

const attributeOptions = ENABLED_SEGMENT_ATTRIBUTES.DUNNING as string[];

interface IAttributeOption {
  label: string;
  value: string;
  custom?: boolean;
}

export default Vue.extend({
  name: 'ExclusionEditor',
  components: {
    VerticalLine,
    SegmentFilterEditor,
    CustomAttributeEditor,
  },
  props: {
    exclusion: {
      type: Object as PropType<Omit<IExclusion, '_id'> & { _id?: string }>,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      showAddCustom: false,
      segmentAttributeLabels,
      attributeOptions,
      name: '',
      filters: [] as ISegmentFilter[],
    };
  },
  async created() {
    this.name = this.exclusion.name;
    this.filters = [...this.exclusion.filters];
    await this.$store.dispatch(FETCH_ORG_PRICES);
    await this.$store.dispatch(FETCH_ORG_PRODUCTS);
    this.loading = false;
  },
  computed: {
    ...mapGetters({
      customAttributesEnabled: 'dunningCustomAttributesEnabled',
    }),
    customAttributes(): ICustomAttribute[] {
      if (!this.customAttributesEnabled) return [];
      const state = this.$store.state as IState;
      return state.org?.customAttributes || [];
    },
    combinedAttributeOptions(): IAttributeOption[] {
      // combine attribute options and customAttributes
      const attributeOptionsCombined = this.attributeOptions.map((attribute) => ({
        label: segmentAttributeLabels[attribute as SegmentAttribute],
        value: attribute,
      }));
      const customAttributes = this.customAttributes.map((attribute) => ({
        label: attribute.label,
        value: attribute.name,
        custom: true,
      }));
      return attributeOptionsCombined.concat(customAttributes);
    },
  },
  methods: {
    update(updates: Partial<IExclusion>) {
      if (updates.name !== undefined) {
        this.name = updates.name;
      }
      if (updates.filters !== undefined) {
        this.filters = updates.filters;
      }
      this.$emit('onEdited', {
        ...this.exclusion,
        ...updates,
      });
    },
    addFilter(attributeKey?: string) {
      let newFilter = {} as ISegmentFilter;
      // for both custom and default attributes
      if (attributeKey) {
        if (this.attributeOptions.includes(attributeKey)) {
          // default attribute
          const attributeType = SEGMENT_ATTRIBUTE_TYPE[attributeKey as SegmentAttribute];
          const operand = [
            SEGMENT_ATTRIBUTE.SUBSCRIPTION_START_DATE,
            SEGMENT_ATTRIBUTE.PRICE,
            SEGMENT_ATTRIBUTE.SUBSCRIPTION_AGE_MONTHS,
            SEGMENT_ATTRIBUTE.BILLING_INTERVAL_COUNT,
            SEGMENT_ATTRIBUTE.INVOICE_AMOUNT_DUE,
          ].includes(attributeKey as SegmentAttribute)
            ? SEGMENT_OPERAND.GTE
            : SEGMENT_OPERAND.INCLUDES;
          const newFilterValue = getDefaultFilterValue(attributeType, operand);
          newFilter = {
            attribute: attributeKey as SegmentAttribute,
            operand,
            value: newFilterValue,
          };
        } else {
          // custom attribute
          const match = this.customAttributes.find((attribute) => attribute.name === attributeKey);
          if (match) {
            let operand: SegmentOperand;
            if (match.type === CUSTOM_ATTRIBUTE_TYPE.NUMBER || match.type === CUSTOM_ATTRIBUTE_TYPE.DATE) {
              operand = SEGMENT_OPERAND.GTE;
            } else {
              operand = SEGMENT_OPERAND.INCLUDES;
            }
            const newFilterValue = getDefaultFilterValue(match.type, operand);
            newFilter = {
              attribute: attributeKey as SegmentAttribute,
              operand,
              value: newFilterValue,
              type: match.type,
            };
          }
        }
      }
      this.update({ filters: [...this.filters, newFilter] });
    },
    removeFilter(index: number) {
      this.update({ filters: this.filters.filter((_, i) => i !== index) });
    },
    updateFilterItem(index: number, data: ISegmentFilter) {
      const filters = [...this.filters];
      filters[index] = data;
      this.update({ filters });
    },
  },
});
